import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _74b54d3c = () => interopDefault(import('../pages/anggota-jdih/index.vue' /* webpackChunkName: "pages/anggota-jdih/index" */))
const _70d1642c = () => interopDefault(import('../pages/beranda/index.vue' /* webpackChunkName: "pages/beranda/index" */))
const _4609eca8 = () => interopDefault(import('../pages/berita/index.vue' /* webpackChunkName: "pages/berita/index" */))
const _e12727fc = () => interopDefault(import('../pages/buku/index.vue' /* webpackChunkName: "pages/buku/index" */))
const _11bd3ff2 = () => interopDefault(import('../pages/dokumen/index.vue' /* webpackChunkName: "pages/dokumen/index" */))
const _6fea2d8f = () => interopDefault(import('../pages/galeri/index.vue' /* webpackChunkName: "pages/galeri/index" */))
const _2d110bf4 = () => interopDefault(import('../pages/hubungi-kami/index.vue' /* webpackChunkName: "pages/hubungi-kami/index" */))
const _6d650531 = () => interopDefault(import('../pages/katalog-perbup/index.vue' /* webpackChunkName: "pages/katalog-perbup/index" */))
const _3bacf742 = () => interopDefault(import('../pages/katalog-perda/index.vue' /* webpackChunkName: "pages/katalog-perda/index" */))
const _4b81a1d8 = () => interopDefault(import('../pages/page/index.vue' /* webpackChunkName: "pages/page/index" */))
const _ab4b02bc = () => interopDefault(import('../pages/pengaduan/index.vue' /* webpackChunkName: "pages/pengaduan/index" */))
const _56ea0950 = () => interopDefault(import('../pages/pengumuman/index.vue' /* webpackChunkName: "pages/pengumuman/index" */))
const _5a022e25 = () => interopDefault(import('../pages/SOP/index.vue' /* webpackChunkName: "pages/SOP/index" */))
const _e237deee = () => interopDefault(import('../pages/statistik/index.vue' /* webpackChunkName: "pages/statistik/index" */))
const _7dade3e0 = () => interopDefault(import('../pages/struktur-organisasi/index.vue' /* webpackChunkName: "pages/struktur-organisasi/index" */))
const _72ec409a = () => interopDefault(import('../pages/tugas-pokok-fungsi-dan-program-kerja/index.vue' /* webpackChunkName: "pages/tugas-pokok-fungsi-dan-program-kerja/index" */))
const _f6625228 = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _0931b9a7 = () => interopDefault(import('../pages/visi-misi/index.vue' /* webpackChunkName: "pages/visi-misi/index" */))
const _982fb800 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _49772f38 = () => interopDefault(import('../pages/berita/_slug.vue' /* webpackChunkName: "pages/berita/_slug" */))
const _e4946a8c = () => interopDefault(import('../pages/buku/_slug.vue' /* webpackChunkName: "pages/buku/_slug" */))
const _4eeee468 = () => interopDefault(import('../pages/page/_slug.vue' /* webpackChunkName: "pages/page/_slug" */))
const _55336808 = () => interopDefault(import('../pages/pengumuman/_slug.vue' /* webpackChunkName: "pages/pengumuman/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/anggota-jdih",
    component: _74b54d3c,
    name: "anggota-jdih"
  }, {
    path: "/beranda",
    component: _70d1642c,
    name: "beranda"
  }, {
    path: "/berita",
    component: _4609eca8,
    name: "berita"
  }, {
    path: "/buku",
    component: _e12727fc,
    name: "buku"
  }, {
    path: "/dokumen",
    component: _11bd3ff2,
    name: "dokumen"
  }, {
    path: "/galeri",
    component: _6fea2d8f,
    name: "galeri"
  }, {
    path: "/hubungi-kami",
    component: _2d110bf4,
    name: "hubungi-kami"
  }, {
    path: "/katalog-perbup",
    component: _6d650531,
    name: "katalog-perbup"
  }, {
    path: "/katalog-perda",
    component: _3bacf742,
    name: "katalog-perda"
  }, {
    path: "/page",
    component: _4b81a1d8,
    name: "page"
  }, {
    path: "/pengaduan",
    component: _ab4b02bc,
    name: "pengaduan"
  }, {
    path: "/pengumuman",
    component: _56ea0950,
    name: "pengumuman"
  }, {
    path: "/SOP",
    component: _5a022e25,
    name: "SOP"
  }, {
    path: "/statistik",
    component: _e237deee,
    name: "statistik"
  }, {
    path: "/struktur-organisasi",
    component: _7dade3e0,
    name: "struktur-organisasi"
  }, {
    path: "/tugas-pokok-fungsi-dan-program-kerja",
    component: _72ec409a,
    name: "tugas-pokok-fungsi-dan-program-kerja"
  }, {
    path: "/video",
    component: _f6625228,
    name: "video"
  }, {
    path: "/visi-misi",
    component: _0931b9a7,
    name: "visi-misi"
  }, {
    path: "/",
    component: _982fb800,
    name: "index"
  }, {
    path: "/berita/:slug",
    component: _49772f38,
    name: "berita-slug"
  }, {
    path: "/buku/:slug",
    component: _e4946a8c,
    name: "buku-slug"
  }, {
    path: "/page/:slug",
    component: _4eeee468,
    name: "page-slug"
  }, {
    path: "/pengumuman/:slug",
    component: _55336808,
    name: "pengumuman-slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
